import styled from 'styled-components'
import { Link as LinkR } from 'react-router-dom'
import { Link as LinkS} from 'react-scroll'
import {MdArrowDropDown} from 'react-icons/md'

export const Nav = styled.nav`
    background: #000;
    height: 80px;
    margin-top: -80px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    position: sticky;
    top: 0;
    z-index: 10;

    @media screen and (max-width: 960px) {
        transition : 0.8s all ease;
    }
`;

export const NavbarContainer = styled.div`
    display: flex;
    justify-content: space-between;
    height: 80px;
    z-index: 1;
    width: 100%;
    padding: 0 24px;
    max-width: 1100px;
`;

export const NavLogo = styled(LinkR)`
    color: #fff;
    justify-self: flex-start;
    cursor: pointer;
    font-size: 1.5rem;
    display : flex;
    align-items: center;
    margin-left: 5px;
    font-weight: bold;
    text-decoration: none;
`;

export const MobileIcon = styled.div`
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #fff;
`;

export const NavMenu = styled.ul`
    display: flex;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-right: 340px;

    @media screen and (max-width: 768px) {
        display: none;
    }
`

export const NavItem = styled.li`
    height: 80px;
`

export const NavLinks = styled(LinkS)`
    color: #fff;
    display: flex;
    align-items: center;
    text-decoration: none;
    padding: 0 1rem;
    height: 100%;
    cursor: pointer;


    &.active{
        border-bottom: 100px solid #01bf71;
    }

    &:hover{
        color: #01bf71;
        transition: 0.2s ease-in-out;
    }
`

export const ArrowDown = styled(MdArrowDropDown)`
    font-size : 20px;
`
export const NavItem1 = styled.li`
    height: 80px;
`
export const NavbarDropdown = styled.div`
    position: relative;
    display: inline-block;


    &:hover {
      display: block;
      >div {
          display: block;
      }
    }
`;
export const NavbarDropdownContent = styled.div`
display: none;
position: absolute;
background-color: #fff;
min-width: 160px;
padding: 12px 16px;
background: #000;
line-height: 2.5;
`;
